import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const COLORS = ["#156F5B", "#4C9F87", "#1F7A8C", "#B58A3C", "#7A5195", "#EF5675", "#2E6F95", "#8A9B41", "#C05746", "#5B7B7A", "#9C6644", "#3D5A80"];
const TICK = { fontSize: 11, fontFamily: "Open Sans" };
const TOOLTIP_STYLE = { background: "#FFFFFF", border: "1px solid #E5E7EB", borderRadius: 6, fontFamily: "Open Sans", fontSize: 12 };
const TOOLTIP_LABEL_STYLE = { color: "#6B7280" };
const LEGEND_STYLE = { fontSize: 12, fontFamily: "Open Sans" };
const X_DOMAIN = ["dataMin", "dataMax"];

const formatDay = (v) => new Date(v).toLocaleDateString(undefined, { month: "short", day: "numeric" });
const formatFull = (v) => new Date(v).toLocaleString();

export function SiteSeriesLineChart({ chartData, siteKeys, unit }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={chartData}>
        <CartesianGrid stroke="#EBF1EF" strokeDasharray="4 4" />
        <XAxis
          dataKey="ts"
          type="number"
          domain={X_DOMAIN}
          scale="time"
          stroke="#9CA3AF"
          tick={TICK}
          tickFormatter={formatDay}
          minTickGap={40}
        />
        <YAxis
          stroke="#9CA3AF"
          tick={TICK}
          label={unit ? { value: unit, angle: -90, position: "insideLeft", fill: "#9CA3AF", fontSize: 11 } : undefined}
        />
        <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={TOOLTIP_LABEL_STYLE} labelFormatter={formatFull} />
        <Legend wrapperStyle={LEGEND_STYLE} />
        {siteKeys.map((k, i) => (
          <Line key={k} type="monotone" dataKey={k} stroke={COLORS[i % COLORS.length]} strokeWidth={2} dot={false} connectNulls />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
